import { render, staticRenderFns } from "./emr-facilities.vue?vue&type=template&id=6b5eb0fd&scoped=true"
import script from "./emr-facilities.vue?vue&type=script&lang=js"
export * from "./emr-facilities.vue?vue&type=script&lang=js"
import style0 from "./emr-facilities.vue?vue&type=style&index=0&id=6b5eb0fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5eb0fd",
  null
  
)

export default component.exports